module.exports = __webpack_public_path__ + "static/media/sa.1c14b2ed.svg";